/** MT5 Web API dashboard — parallel to dashboard.js (MySQL). */
import { appendTokenSearchParams, buildAuthHeaders, formatApiError, getApiToken, normalizeApiBase } from './auth';

const API_BASE = normalizeApiBase();

export async function fetchDashboardMt5Overview({
  segment = 'wh',
  period = 'today',
  startDate,
  endDate,
  depositStartDate,
  depositEndDate,
  debug = false,
  signal,
} = {}) {
  if (!getApiToken()) {
    throw new Error(
      'Missing API token — set REACT_APP_API_TOKEN in websocket/.env (same as EXPECTED_TOKEN)'
    );
  }

  const path =
    segment === 'stp'
      ? '/api/dashboard/mt5/stp/overview'
      : '/api/dashboard/mt5/overview';

  const params = appendTokenSearchParams(new URLSearchParams({ period, segment }));
  if (debug) params.set('debug', 'true');
  if (startDate && endDate) {
    params.set('start_date', startDate);
    params.set('end_date', endDate);
  }
  if (depositStartDate && depositEndDate) {
    params.set('deposit_start_date', depositStartDate);
    params.set('deposit_end_date', depositEndDate);
  }

  const res = await fetch(`${API_BASE}${path}?${params}`, {
    headers: buildAuthHeaders(),
    signal,
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const msg = formatApiError(err, res.status);
    console.error('[MT5 dashboard] request failed', {
      status: res.status,
      url: res.url,
      detail: msg,
    });
    throw new Error(
      res.status === 503
        ? `${msg} — MT5 server unreachable from this PC (VPN/firewall/DNS?). SQL dashboard still works.`
        : msg
    );
  }
  const data = await res.json();
  if (data.debug_info) {
    console.group('[MT5 dashboard] debug_info');
    console.log('steps:', data.debug_info.steps);
    Object.entries(data.debug_info).forEach(([key, val]) => {
      if (key !== 'steps') console.log(key, val);
    });
    console.groupEnd();
  }
  if (
    data.floating?.total_floating === 0 &&
    !data.floating?.per_login?.length &&
    data.debug_info
  ) {
    console.warn(
      '[MT5 dashboard] All zeros — check debug_info above. Common fixes:',
      'set MT5_DASHBOARD_GROUP to a real group (not *), add client logins to MT5_DASHBOARD_EXTRA_LOGINS'
    );
  }
  return data;
}
